import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M2466 6488 c-19 -24 -56 -70 -82 -103 -26 -33 -83 -103 -126 -156
-43 -53 -78 -101 -78 -108 0 -8 193 -11 736 -11 660 0 740 -2 770 -16 71 -34
87 -108 35 -166 l-29 -33 -766 -3 -766 -3 2 -492 3 -492 830 0 c773 0 835 1
899 18 38 10 76 22 85 27 9 4 37 17 64 29 213 95 293 397 161 607 -40 64 -76
98 -133 126 l-44 21 28 21 c60 45 125 117 147 163 19 41 22 64 22 163 0 100
-3 122 -24 168 -13 28 -27 52 -32 52 -4 0 -8 6 -8 13 0 19 -78 90 -135 123
-82 47 -120 59 -270 84 -35 5 -314 10 -657 10 l-597 0 -35 -42z m1216 -958
c117 -33 100 -183 -23 -209 -55 -12 -862 -14 -939 -3 l-45 7 -3 94 c-1 52 -1
100 2 108 4 10 97 13 488 13 300 0 497 -4 520 -10z"
          />
          <path
            d="M4819 6503 c-24 -28 -193 -244 -256 -329 -18 -24 -33 -48 -33 -54 0
-6 275 -10 765 -12 595 -2 767 -6 777 -15 6 -7 18 -13 26 -13 46 0 122 -104
122 -166 0 -58 -50 -119 -128 -156 l-47 -23 -745 -2 c-410 -2 -755 -5 -768 -8
l-22 -5 2 -408 3 -407 239 -3 c165 -2 243 1 252 9 10 8 14 58 16 213 l3 201
378 3 c208 1 384 -1 391 -5 12 -7 110 -119 170 -194 48 -59 124 -148 160 -186
l40 -43 324 0 c274 0 323 2 320 14 -5 23 -402 439 -460 483 l-29 21 23 16 c12
9 28 16 35 16 8 0 45 16 84 35 195 99 302 313 270 542 -17 120 -57 200 -146
288 -115 115 -238 166 -495 205 -36 5 -324 9 -656 10 l-591 0 -24 -27z"
          />
          <path
            d="M7194 6524 c-7 -3 -59 -67 -115 -142 -57 -75 -106 -139 -109 -142 -3
-3 -21 -25 -40 -50 -19 -25 -38 -46 -42 -48 -5 -2 -8 -10 -8 -18 0 -11 61 -14
373 -16 l372 -3 5 -600 c3 -330 7 -601 8 -603 1 -1 113 -1 250 0 l247 3 3 594
c2 461 5 597 15 603 6 4 138 8 293 8 l281 0 24 28 c13 15 35 43 49 62 13 19
49 67 80 105 31 39 70 90 87 115 17 25 41 55 53 68 11 12 18 27 15 32 -6 10
-1817 14 -1841 4z"
          />
          <path
            d="M8215 4592 c-130 -23 -201 -127 -145 -217 23 -38 71 -60 159 -74 85
-14 113 -33 109 -74 -4 -44 -37 -59 -110 -53 -38 4 -72 15 -99 31 l-41 26 -24
-26 c-29 -32 -30 -39 -3 -66 37 -37 109 -61 184 -61 129 0 195 52 195 155 0
48 -4 61 -30 90 -32 37 -114 67 -182 67 -42 0 -80 37 -71 69 11 42 127 54 182
19 18 -11 24 -9 47 14 15 14 24 33 21 41 -12 31 -134 69 -192 59z"
          />
          <path
            d="M6342 4578 c-79 -12 -139 -54 -175 -123 -16 -31 -20 -58 -20 -120 0
-98 16 -138 76 -191 71 -63 167 -79 274 -48 157 46 217 251 115 392 -53 73
-154 107 -270 90z m148 -110 c46 -31 68 -74 69 -131 1 -56 -15 -91 -58 -129
-27 -25 -39 -28 -100 -28 -68 0 -72 1 -111 38 -41 40 -47 59 -41 142 3 41 33
90 70 112 41 25 131 23 171 -4z"
          />
          <path
            d="M5486 4570 c-114 -35 -184 -170 -156 -303 12 -59 55 -128 92 -149 92
-51 214 -51 306 0 29 17 28 43 -4 73 -25 23 -26 23 -55 6 -20 -11 -52 -17 -91
-17 -72 0 -119 28 -143 87 -17 41 -20 99 -5 108 6 3 10 14 10 24 0 19 49 71
68 71 7 0 12 5 12 10 0 16 98 12 131 -6 34 -17 58 -13 84 16 16 18 16 20 -10
44 -15 14 -44 30 -64 36 -43 12 -135 12 -175 0z"
          />
          <path
            d="M2167 4564 c-10 -10 -9 -62 1 -68 5 -3 28 -6 53 -7 97 -4 89 13 89
-193 0 -198 2 -206 55 -206 53 0 55 8 55 207 0 167 2 183 18 184 9 1 39 3 65
4 57 2 70 13 65 51 l-3 29 -196 3 c-107 1 -198 -1 -202 -4z"
          />
          <path
            d="M2987 4563 c-13 -12 -8 -448 5 -461 13 -13 314 -17 334 -4 11 6 18
39 15 70 -1 9 -31 12 -115 12 -63 0 -121 3 -130 6 -22 9 -22 89 0 98 9 3 63 6
120 6 l105 0 -3 43 -3 42 -115 5 -115 5 0 45 0 45 120 5 120 5 3 43 3 42 -169
0 c-93 0 -172 -3 -175 -7z"
          />
          <path
            d="M3787 4564 c-4 -4 -7 -110 -7 -235 0 -227 0 -227 23 -233 12 -3 83
-6 158 -6 152 0 173 7 167 55 l-3 30 -100 2 c-160 4 -144 -18 -147 201 l-3
187 -40 3 c-23 2 -44 0 -48 -4z"
          />
          <path
            d="M4557 4564 c-4 -4 -7 -105 -7 -224 0 -158 3 -221 13 -233 11 -16 31
-17 182 -15 l170 3 0 40 0 40 -125 5 -125 5 0 50 0 50 115 5 c114 5 114 5 113
30 -1 63 6 59 -115 62 l-113 3 0 45 0 45 120 5 120 5 0 40 0 40 -171 3 c-93 1
-173 -1 -177 -4z"
          />
          <path
            d="M7092 4333 l3 -238 45 0 45 0 3 158 c1 86 6 157 10 157 10 0 60 -54
97 -105 53 -74 58 -73 131 18 65 79 74 88 86 81 4 -3 8 -72 8 -154 l0 -150 26
-6 c14 -4 36 -2 50 5 l24 11 -2 227 -3 228 -55 3 c-30 1 -60 -1 -66 -5 -6 -5
-36 -43 -68 -85 -31 -43 -63 -78 -70 -78 -8 0 -33 26 -56 58 -80 107 -87 112
-152 112 l-58 0 2 -237z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
